























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Comissao extends Vue {
  @Prop({ type: Boolean, default: false }) private showDialog: boolean;
  @Prop(Object) private organizacao!: any;
  private dialog: boolean = false;

  @Watch("showDialog")
  private showDialogChanged(newValue: boolean, oldValue: boolean) {
    this.dialog = newValue;
  }

  private hide() {
    this.$emit("hidden");
  }
}
